import {
  buildHeader,
  buildParagraph,
  createTableHeaderCell,
  createTableCell,
  buildNewlines,
} from "./helpers";
import { Table, TableRow } from "docx";
import { getMasteryColor } from "../../utilities/masteryUtils";
import { millisecondsToMinutes, getUsageTimeColor, formatTimeDisplay, formatStoryCount } from "./utils/formatUtils";

const createSectionGoals = (
  studentData,
  weeklyPlan,
  metrics,
  focuses,
  masteriesWithEmbeddedFocus
) => [
  // Usage Goals Header
  buildHeader("Usage Goals", 3),
  // Usage Goals Table
  createUsageGoalsTable(metrics),
  // Skills Goals Header
  buildHeader("Skills Goals for Module [TODO] [Mock: 2]", 3),
  // Skills Goals Table
  createSkillsGoalsTable(masteriesWithEmbeddedFocus),
  // TODO: ADD SPECIAL SKILLS Special Skills Goals Header
  //buildHeader(`Special Skills Goals for ${studentData.firstName}`, 3),
  // TODO: ADD SPECIAL SKILLS Special Skills Goals Table
  //buildParagraph("[TODO] Populate and Color Table", { italics: true }),
  //createSpecialSkillsGoalsTable(studentData),
  // TODO: ADD NEXT TARGET SKILLS Next Target Skills Header
  //buildHeader(`Next Target Skills For ${studentData.firstName}`, 3),
  //buildParagraph("[TODO] Populate and Color Table", { italics: true }),
  //createNextTargetSkillsTable(weeklyPlan),
  // Fancy Graph??
  //...buildNewlines(4),
  //buildParagraph("[TODO] Placeholder: Fancy Graph]", { italics: true }),
  //...buildNewlines(4),
];

const createUsageGoalsTable = (metrics) => {
  // sessionTime = High Quality Time, complianceTime = Total Time
  // Convert milliseconds to minutes with proper formatting
  
  // Year metrics
  const yearTotalTime = millisecondsToMinutes(metrics.year.complianceTime?.sum);
  const yearHighQualityTime = millisecondsToMinutes(metrics.year.sessionTime?.sum);
  const yearStories = metrics.year.activityCount?.total || 0;
  
  // Week metrics  
  const weekTotalTime = millisecondsToMinutes(metrics.week.complianceTime?.sum);
  const weekHighQualityTime = millisecondsToMinutes(metrics.week.sessionTime?.sum);
  const weekStories = metrics.week.activityCount?.total || 0;

  // Apply color coding based on high quality time (30+ minutes is good)
  const yearTotalColor = getUsageTimeColor(yearTotalTime);
  const yearHighQualityColor = getUsageTimeColor(yearHighQualityTime);
  const weekTotalColor = getUsageTimeColor(weekTotalTime);
  const weekHighQualityColor = getUsageTimeColor(weekHighQualityTime);

  return new Table({
    columnWidths: [6500, 1250, 1250],
    rows: [
      new TableRow({
        children: [
          createTableHeaderCell(""),
          createTableHeaderCell("This Year"),
          createTableHeaderCell("This Week"),
        ],
      }),
      new TableRow({
        children: [
          createTableCell({
            text: "Number of Stories",
          }),
          createTableCell({
            text: formatStoryCount(yearStories),
            fontColor: yearTotalColor,
          }),
          createTableCell({
            text: formatStoryCount(weekStories),
            fontColor: weekTotalColor,
          }),
        ],
      }),
      new TableRow({
        children: [
          createTableCell({
            text: "Total Time",
          }),
          createTableCell({
            text: formatTimeDisplay(yearTotalTime),
            fontColor: yearTotalColor,
          }),
          createTableCell({
            text: formatTimeDisplay(weekTotalTime),
            fontColor: weekTotalColor,
          }),
        ],
      }),
      new TableRow({
        children: [
          createTableCell({
            text: "High Quality Time",
          }),
          createTableCell({
            text: formatTimeDisplay(yearHighQualityTime),
            fontColor: yearHighQualityColor,
          }),
          createTableCell({
            text: formatTimeDisplay(weekHighQualityTime),
            fontColor: weekHighQualityColor,
          }),
        ],
      }),
    ],
  });
};



const createSkillsGoalsTable = (masteriesWithEmbeddedFocus) => { 
  return new Table({
    columnWidths: [6500, 1250, 1250],
    rows: [
      new TableRow({
        children: [
          createTableHeaderCell(""),
          createTableHeaderCell("Start of Week"),
          createTableHeaderCell("End of Week"),
        ],
      }),
      ...masteriesWithEmbeddedFocus.map(
        (mastery) => {
          // Get current mastery level (start of week)
          const startOfWeekPacing = mastery.weekStartPacing;
          const startOfWeekColor = getMasteryColor(startOfWeekPacing);
          
          // Use current pacing for end of week (could be different if student improved)
          const endOfWeekPacing = mastery.currentPacing;
          const endOfWeekColor = getMasteryColor(endOfWeekPacing);
          
          return new TableRow({
            children: [
              createTableCell({
                text: mastery.focus.displayName,
              }),
              createTableCell({
                text: " ",
                shadingColor: startOfWeekColor,
              }),
              createTableCell({
                text: " ",
                shadingColor: endOfWeekColor,
              }),
            ],
          });
        }
      ),
    ],
  });
};

const createSpecialSkillsGoalsTable = (studentData) => {
  return new Table({
    columnWidths: [6500, 2500],
    rows: [
      new TableRow({
        children: [
          createTableHeaderCell(
            `These are the skills that ${studentData.firstName} is gapped on:`
          ),
          createTableHeaderCell("Now"),
        ],
      }),
      ...[].map(
        (focus) =>
          new TableRow({
            children: [
              createTableCell({
                text: focus.displayName,
              }),
              createTableCell({
                text: "", // TODO: Populate color correctly
                shadingColor: "D70040",
              }),
            ],
          })
      ),
    ],
  });
};

const createNextTargetSkillsTable = () => {
  return new Table({
    columnWidths: [6500, 1250, 1250],
    rows: [
      new TableRow({
        children: [
          createTableHeaderCell(""),
          createTableHeaderCell("Now"),
          createTableHeaderCell("Goal"),
        ],
      }),
      ...[].map(
        (targetSkill) =>
          new TableRow({
            children: [
              createTableCell({
                text: targetSkill,
              }),
              createTableCell({
                text: "", // TODO: Populate color correctly
              }),
              createTableCell({
                text: "", // TODO: Populate color correctly
              }),
            ],
          })
      ),
    ],
  });
};

export default createSectionGoals;
